// web/src/features/competition/wizard/hooks/useOrgCompetitions.ts
import { useQuery } from '@tanstack/react-query'
import { listOrgCompetitions } from '@sportninja/common/services/competition'
import { queryKeys } from '@sportninja/common/config/queryKeys'

type Filters = {
  sportId?: string | null
  genericSportId?: string | null
}

export const useOrgCompetitions = (
  orgId: string | null,
  search: string,
  filters: Filters = {}
) => {
  return useQuery({
    queryKey: queryKeys.orgCompetitions.bySearch(orgId, search, filters),
    queryFn: () =>
      listOrgCompetitions(orgId as string, {
        search: search || undefined,
        sportId: filters.sportId ?? undefined,
        genericSportId: filters.genericSportId ?? undefined,
      }),
    enabled: Boolean(orgId),
    staleTime: 1000 * 60, // 1 minute — picker results
  })
}
